module.exports = __webpack_public_path__ + "static/media/482.8fc55e94.svg";